// extracted by mini-css-extract-plugin
export default {"search_field":"PatientProgress_search_field__FruLy","filter_dropdown":"PatientProgress_filter_dropdown__DnxIl"};